import { Directive } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { helperFunctions } from 'src/app/utils/cf-checker-util';

export function ValidateCognomeCF(control: AbstractControl): {[key: string]: any} | null  {
    
    if (control.parent && control.parent.get('cognomeDenominazione').value && control.parent.get('nome').value && control.parent.get('sesso').value && control.parent.get('codiceFiscale').value) {
        const cognome = control.parent.get('cognomeDenominazione').value;
        const nome = control.parent.get('nome').value;
        const sesso = control.parent.get('sesso').value;
        const CF = control.parent.get('codiceFiscale').value;
    
        const cfCheckerResult = helperFunctions.checkCodiceFiscale(cognome, nome, null, sesso, null, CF, false);
        return (cfCheckerResult === true) ? null : (cfCheckerResult.includes("Il cognome non corrisponde al CF !!"))? { cognomecfnotvalid: true } : null;
    }
    
    return null; // return null if validation is passed.
}

@Directive({
  selector: '[appCognomeCFValidatorDirective]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: AppCognomeCFValidatorDirective,
    multi: true
  }]
})
export class AppCognomeCFValidatorDirective implements Validator {
  validate(control: AbstractControl) : {[key: string]: any} | null {
    return ValidateCognomeCF(control);
  }
}